import React from "react";
import { Card, CardHeader, IconButton, Stack, Typography } from "@mui/material";

import MessageAvatar from "./MessageAvatar";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import RenderDate from "../../../Common/Date/RenderDate";
import LinkButton from "../../../Common/Button/LinkButton";

const MessageCard = ({ message, onDelete }) => {
    const fromName = message?.from?.name?.length
        ? message.from.name
        : "Unknown";
    const initial = fromName.substring(0, 1);
    const subject =
        message?.subject?.length > 0
            ? ` - ${message.subject}`
            : " - No subject";

    return (
        <Card className="card">
            <CardHeader
                disableTypography={true}
                avatar={<MessageAvatar initial={initial} />}
                title={
                    <Typography component="h2" className="card-header-title">
                        {fromName}
                    </Typography>
                }
                subheader={
                    <Typography
                        component="span"
                        className="card-header-subtitle"
                    >
                        {!!message?.createdAt && (
                            <RenderDate date={message.createdAt} />
                        )}
                        {subject}
                    </Typography>
                }
                action={
                    <Stack
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={2}
                        sx={{ padding: "8px" }}
                    >
                        <IconButton aria-label="delete" onClick={onDelete}>
                            <DeleteOutlinedIcon />
                        </IconButton>
                        <LinkButton to={`/messages/${message.id}`} />
                    </Stack>
                }
            />
        </Card>
    );
};

export default MessageCard;
